import {TTableReportColumn} from 'store/slices/table-report-slice/table-report-slice-types';

export const DOCUMENT_COLUMNS: TTableReportColumn[] = [
    {
        title: 'id документа',
        dataIndex: 'docId',
        key: 1,
        permanentlyHidden: false,
    },
    {
        title: 'Тип документа',
        dataIndex: 'docType',
        key: 2,
        permanentlyHidden: false,
    },
    {
        title: 'Дата создания документа',
        dataIndex: 'createdDate',
        key: 3,
        permanentlyHidden: false,
    },
    {
        title: 'Кто создал документ',
        dataIndex: 'createdBy',
        key: 4,
        permanentlyHidden: false,
    },
];

export const CHILD_TYPES = {
    DOCUMENT: 'document',
    ROW: 'row',
    MESSAGE: 'message',
};
